// Accordion functionality for native <details> elements
export default function () {
  const accordionItems = document.querySelectorAll('.accordion-item')

  if (accordionItems.length === 0) return

  accordionItems.forEach((details) => {
    details.addEventListener('toggle', function () {
      // Only act when opening (details has 'open' attribute)
      if (this.hasAttribute('open')) {
        // Close all other open accordions on the page
        document.querySelectorAll('.accordion-item[open]')
          .forEach((otherDetails) => {
            if (otherDetails !== this) {
              otherDetails.removeAttribute('open')
            }
          })
      }
    })
  })
}
